(ns minorodata.ai-chat.byol
  (:require [clojure.set :as set]
            [clojure.string :as string]))


(def providers
  [{:id "openai"    :name "OpenAI"}
   {:id "anthropic" :name "Anthropic"}
   {:id "google"    :name "Google Gemini"}])


(defn provider-name [provider-id]
  (some #(when (= provider-id (:id %)) (:name %)) providers))


(defn credential-for [credentials provider-id]
  (some #(when (= provider-id (:provider %)) %) credentials))


(defn validated? [credential]
  (= "ok" (:validation credential)))


(defn validated-providers [credentials]
  (filterv (fn [{:keys [id]}]
             (let [credential (credential-for credentials id)]
               (and (validated? credential) (seq (:models credential)))))
           providers))


(defn provider-options [credentials]
  (mapv (fn [{:keys [id name]}] {:value id :text name})
        (validated-providers credentials)))


(defn model-options [credentials provider-id]
  (let [credential (credential-for credentials provider-id)]
    (mapv (fn [model] {:value model :text model})
          (when (validated? credential) (:models credential)))))


(defn approved-value [provider model]
  (str provider "/" model))


(defn parse-approved-value [value]
  (let [[provider model] (string/split value #"/" 2)]
    {:provider provider :model model}))


(defn approved-model-options [credentials]
  (vec (for [{:keys [id name]} (validated-providers credentials)
             model              (:models (credential-for credentials id))]
         {:value (approved-value id model)
          :text  (str model " · " name)})))


(defn approved-values [approved-models]
  (mapv #(approved-value (:provider %) (:model %)) approved-models))


(defn ->approved-models [values]
  (mapv parse-approved-value (sort values)))


(defn with-default-approved [approved-models provider model]
  (let [entry {:provider provider :model model}]
    (if (or (nil? model)
            (some #(= entry (select-keys % [:provider :model])) approved-models))
      (vec approved-models)
      (conj (vec approved-models) entry))))


(def key-placeholders
  {"openai"    "sk-…"
   "anthropic" "sk-ant-…"
   "google"    "AIza…"})


(defn model-label [{:keys [provider model]}]
  (str model " · " (provider-name provider)))


(defn model-choices [{:ai-settings/keys [default-provider default-model approved-models]}]
  (when default-model
    (into [{:provider default-provider :model default-model :default? true}]
          (comp (remove #(= default-model (:model %)))
                (map #(select-keys % [:provider :model])))
          approved-models)))


(defn chosen-model [{:ai-settings/keys [byol-effective allow-user-model-selection] :as settings} chosen]
  (when (and byol-effective
             allow-user-model-selection
             (some #(and (= chosen (:model %)) (not (:default? %)))
                   (model-choices settings)))
    chosen))


(defn active-choice [settings chosen]
  (let [choices  (model-choices settings)
        override (chosen-model settings chosen)]
    (or (some #(when (= override (:model %)) %) choices)
        (first choices))))


(defn kai-default? [{:ai-settings/keys [assistant-enabled byol-enabled byol-effective credential-versions]}]
  (boolean (and (not (false? assistant-enabled))
                byol-enabled
                (seq credential-versions)
                (not byol-effective))))


(defn approved-models-change [before after]
  (let [before-values (set (approved-values before))
        after-values  (set (approved-values after))]
    {:models_added          (vec (sort (set/difference after-values before-values)))
     :models_removed        (vec (sort (set/difference before-values after-values)))
     :approved_models_count (count after)
     :providers_in_list     (vec (sort (distinct (map :provider after))))}))


(defn parse-service-account [text]
  (when (string? text)
    (try
      (let [parsed (js->clj (js/JSON.parse text) :keywordize-keys true)]
        (when (map? parsed) parsed))
      (catch :default _
        nil))))


(defn credential-body [{:keys [provider type value label]}]
  (cond-> {:provider   provider
           :credential {:type type :value value}}
    (not (string/blank? label)) (assoc :label label)))


(defn save-error-message [{:keys [status response]}]
  (cond
    (= 403 status)
    "Enable BYOL before adding a provider key."

    (= "failed" (:validation response))
    (str "Validation failed"
         (when-let [reason (:reason response)] (str ": " reason))
         ". Nothing was stored.")

    (and (= 400 status) (string? (:error response)))
    (:error response)

    :else
    "Failed to save the provider key."))


(defn settings-error-message [{:keys [status response]}]
  (if (and (= 400 status) (string? (:error response)))
    (:error response)
    "Failed to update Kai settings"))
